import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Card } from "@/components/erp/ui";
import { useAuth } from "@/context/AuthContext";
import { Pos, Products, Cashiers } from "@/components/erp/store/StoreParts";
import { Consign } from "@/components/erp/store/Consign";
import { Daily } from "@/components/erp/store/Receipt";

export default function Store() {
  const { user } = useAuth();
  const [d, setD] = useState(null); const [tab, setTab] = useState("");
  const load = () => api.get("/store/products").then(({ data }) => { setD(data); setTab((t) => t || (data.can_pos ? "pos" : "products")); }).catch((e) => setD({ denied: e?.response?.data?.detail || "Tidak punya akses" }));
  useEffect(() => { load(); }, []);
  if (!d) return null;
  if (d.denied) return <div><PageHeader title="Toko Offline" subtitle="POS kasir toko, stok produk display toko, dan konsinyasi." /><Card className="p-5 text-sm text-slate-500" data-testid="store-denied">{d.denied}. Minta admin utama menambahkan Anda sebagai kasir.</Card></div>;
  const isOwner = user?.role === "owner";
  const tabs = [d.can_pos && ["pos", "POS Kasir"], (d.can_pos || d.can_manage) && ["daily", "Laporan Harian"], ["products", "Produk Display Toko"], d.can_manage && ["consign", "Konsinyasi"], isOwner && ["cashiers", "Akses Kasir"]].filter(Boolean);
  return (
    <div>
      <PageHeader title="Toko Offline" subtitle="POS kasir toko, stok produk display toko, dan konsinyasi ke toko mitra." />
      <div className="flex flex-wrap gap-2 mb-4">{tabs.map(([k, l]) => <button key={k} type="button" data-testid={`store-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-1.5 rounded-full text-sm font-semibold border transition-colors ${tab === k ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 bg-white"}`}>{l}</button>)}</div>
      {tab === "pos" && <Pos prods={d.rows} reload={load} />}
      {tab === "daily" && <Daily />}
      {tab === "products" && <Products prods={d.rows} canManage={d.can_manage} isOwner={isOwner} reload={load} />}
      {tab === "consign" && <Consign prods={d.rows} reloadProds={load} />}
      {tab === "cashiers" && <Cashiers />}
    </div>
  );
}
